import {
  FractureEnum,
  FurcationEnum,
  MobilityEnum,
  ResorptionEnum,
  ToothStateEnum
} from "requests";

export const TOOTH_STATE_OPTIONS = [
  { value: ToothStateEnum.Untreated, label: "Untreated" },
  { value: ToothStateEnum.Abnormal, label: "Abnormal" },
  { value: ToothStateEnum.Missing, label: "Missing" },
  { value: ToothStateEnum.Extracted, label: "Extracted" },
  { value: ToothStateEnum.Treated, label: "Treated" },
  { value: ToothStateEnum.Unerupted, label: "Unerupted" }
];

export const FURCATION_OPTIONS = [
  { value: FurcationEnum.F1, label: "F1" },
  { value: FurcationEnum.F2, label: "F2" },
  { value: FurcationEnum.F3, label: "F3" }
];

export const MOBILITY_OPTIONS = [
  { value: MobilityEnum.M1, label: "M1" },
  { value: MobilityEnum.M2, label: "M2" },
  { value: MobilityEnum.M3, label: "M3" }
];

export const FRACTURE_OPTIONS = [
  { value: FractureEnum.TFxEf, label: "T/FX/EF" },
  { value: FractureEnum.TFxUcf, label: "T/FX/UCF" },
  { value: FractureEnum.TFxCcf, label: "T/FX/CCF" },
  { value: FractureEnum.TFxUcrf, label: "T/FX/UCRF" },
  { value: FractureEnum.TFxCcrf, label: "T/FX/CCRF" },
  { value: FractureEnum.TFxRf, label: "T/FX/RF" }
];

export const RESORPTION_OPTIONS = [
  { value: ResorptionEnum.Tr1, label: "TR1" },
  { value: ResorptionEnum.Tr2, label: "TR2" },
  { value: ResorptionEnum.Tr3, label: "TR3" },
  { value: ResorptionEnum.Tr4, label: "TR4" },
  { value: ResorptionEnum.Tr5, label: "TR5" }
];
